module.exports = __webpack_public_path__ + "img/mengyang-xiaochengxu.7d0680fa.jpg";